import styled, { css } from 'styled-components';
import { Form } from '~/ui/components';

export const StyledForm = styled(Form)<{ disabled?: boolean; overflow?: string }>`
  position: relative;
  max-width: 740px;
  overflow: auto;

  .input-list {
    max-width: 717px;
    max-height: 685px;
    overflow: ${({ overflow }) => overflow || 'auto'};
    padding-right: 12px;

    position: relative;
    z-index: 11;
    cursor: auto;

    @media (max-width: 1220px) {
      max-height: 420px;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }
  }

  .ant-form-explain {
    position: absolute;
    margin-top: 0px;
  }

  .extra-content {
    align-self: end;
    margin-right: 24px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      &::after {
        content: '';
        position: absolute;
        inset: 0;
        z-index: 10;
        background: transparent;
        pointer-events: auto;
        cursor: not-allowed;
      }

      * {
        cursor: not-allowed;
      }

      .input-list {
        position: relative;
        z-index: 11;
        pointer-events: auto;
        cursor: not-allowed;
      }

      .input-list * {
        pointer-events: none;
      }

      button[type='submit'] {
        position: relative;
        z-index: 12;
        pointer-events: auto;
        cursor: pointer;

        span {
          cursor: pointer;
        }
      }
    `}
`;

export const Flex = styled.div`
  display: flex;

  @media (max-width: 1220px) {
    flex-direction: column;
    gap: 16px;
    align-items: center;

    #id {
      order: 1;
    }

    #form {
      order: 2;
    }
  }
`;
